/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Summeroccflowsetpoint3Inputs */



/**
* | output |
* | --- |
* | "Summer occupied flow setpoint" |
*
* @param {Ahu_History_Key_Summeroccflowsetpoint3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_summeroccflowsetpoint3 = /** @type {((inputs?: Ahu_History_Key_Summeroccflowsetpoint3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Summeroccflowsetpoint3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Summer occupied flow setpoint")
	return /** @type {LocalizedString} */ ("Consigne occupation été")
});
export { ahu_history_key_summeroccflowsetpoint3 as "ahu_history_key_summerOccFlowSetpoint" }